import {Inject, Injectable} from '@angular/core';
import {DOCUMENT} from '@angular/common';
import {BehaviorSubject} from 'rxjs';
import {Title} from "@angular/platform-browser";
import {environment} from "../../environments/environment";

@Injectable({
  providedIn: 'root'
})
export class ThemeService {
  private styleName: string  | null = null;
  themeToLoad: string | undefined;
  domainsToCheck: string[] = ['head', 'mares', 'tyrolia', 'divessi', 'zoggs' ]
  theme$: BehaviorSubject<string> = new BehaviorSubject<string>('');

  constructor(@Inject(DOCUMENT) private document: Document,
              private titleService: Title) {

  }
  autoLoadTheme() {
    this.themeToLoad = this.checkDomain();
    this.theme$.next(this.themeToLoad);
    //console.log(this.themeToLoad);
    this.loadStyle(this.themeToLoad);
  }
  checkDomain(): string {
    const domain = document.location.host;
    // console.log(domain);
    for(const entry of this.domainsToCheck) {
      let i: number = domain.indexOf(entry);
      if (i !== -1) {
        let newTitle = entry.toUpperCase() + ' DAM';
        this.titleService.setTitle(newTitle);
        return entry
      }
    }
    let newTitle = 'LOCAL' + ' DAM';
    this.titleService.setTitle(newTitle);
   return 'head';


  }

  loadStyle(styleName: string) {
    if (this.styleName === styleName) {
      return;
    }
    const head = this.document.getElementsByTagName('head')[0];

    const themeLink = this.document.getElementById(
        'client-theme'
    ) as HTMLLinkElement;
    if (themeLink) {
      themeLink.href = styleName + '.css?' + environment.sentryRelease;
    } else {
      const style = this.document.createElement('link');
      style.id = 'client-theme';
      style.rel = 'stylesheet';
      style.href = `${styleName}` + '.css?' + environment.sentryRelease;
      head.appendChild(style);
    }
    this.styleName = styleName;
    const body = this.document.getElementsByTagName('body')[0];
    const className = 'theme-' + this.styleName;
    body.classList.add(className);
  }
  addBodyClass(className: string) {
    const body = this.document.getElementsByTagName('body')[0];
    body.classList.add(className);
  }
  removeBodyClass(className: string) {
    const body = this.document.getElementsByTagName('body')[0];
    body.classList.remove(className);
  }
}
